import { useQuery } from "@apollo/react-hooks";
import { Card, Page } from "@shopify/polaris";
import React, { useCallback, useReducer, useState } from "react";
import { useAppContext } from "../../context";
import { GET_CHANNEL_TEAMS } from "../../graphql/queries/channel-team";
import { checkRole, reducerFn } from "../../helper";
import ChannelTeamCreate from "./actions/channel-team-create";
import ChannelTeamFilter from "./channel-team-filter";
import ChannelTeamTable from "./channel-team-table";
import ChannelTeamContextProvider from "./context";
import { get } from "lodash";

function ChannelTeam() {
    const { currentUser } = useAppContext();
    const { isSeller, isChannelLeader } = checkRole(currentUser);
    const isLeader = isSeller || isChannelLeader;

    const [open, setOpen] = useState(false);
    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    const handleOpen = useCallback(() => {
        setOpen(true);
    }, []);

    return (
        <Page
            title="Channel Teams"
            fullWidth
            primaryAction={
                isLeader
                    ? {
                          content: "Create ChannelTeam",
                          onAction: () => handleOpen(),
                      }
                    : null
            }
        >
            <Card sectioned>
                <ChannelTeamFilter />
            </Card>
            <Card>
                <ChannelTeamTable />
            </Card>

            <ChannelTeamCreate open={open} onClose={handleClose} />
        </Page>
    );
}

export default function ChannelTeamWrap() {
    const [filter, setFilter] = useReducer(reducerFn, {
        limit: 20,
        offset: 0,
        search: "",
    });

    const { data, loading, error, refetch } = useQuery(GET_CHANNEL_TEAMS, {
        variables: {
            filter,
        },
        fetchPolicy: "no-cache",
    });

    return (
        <ChannelTeamContextProvider
            filter={filter}
            setFilter={setFilter}
            loading={loading}
            error={error}
            total={getTotal(data)}
            channelTeams={getChannelTeams(data)}
            refetch={refetch}
        >
            <ChannelTeam />
        </ChannelTeamContextProvider>
    );
}

function getTotal(data) {
    return get(data, "getChannelTeams.total");
}

function getChannelTeams(data) {
    return get(data, "getChannelTeams.nodes") || [];
}
